import { T, useGT } from 'gt-react';
import type { UploadLayout } from '@erp/rpc';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface Props {
  layouts: UploadLayout[];
  value: string | null;
  onChange: (layoutId: string) => void;
}

/** The supplier the file on the page is converted for; changing it re-converts. */
export function SupplierPicker({ layouts, value, onChange }: Props) {
  const gt = useGT();
  return (
    <div className="flex flex-wrap items-center gap-2 text-sm">
      <span>
        <T context="label before the supplier picker">Supplier</T>
      </span>
      <Select
        value={value ?? ''}
        onValueChange={(next) => {
          if (typeof next === 'string' && next !== '') onChange(next);
        }}
      >
        <SelectTrigger className="h-8 w-44">
          <SelectValue
            placeholder={gt('Choose a supplier', {
              context: 'placeholder of the supplier picker',
            })}
          />
        </SelectTrigger>
        <SelectContent>
          {layouts.map((layout) => (
            <SelectItem key={layout.id} value={layout.id}>
              {layout.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
